/* eslint-disable react-hooks/exhaustive-deps */

import * as THREE from 'three'
import React from 'react'
import { useHistory } from 'react-router'
import { ReactReduxContext, Provider } from 'react-redux';
import { Canvas } from 'react-three-fiber'
import { VRCanvas, DefaultXRControllers } from '@react-three/xr'
import { setVideo, setInfo, setMenu, setCurrentStep, setMenuContent, setCurrentGama, setCurrentCollection } from '../../effects/actions'

import { VRButton } from './VRButton'
import VRMain from './main'
import VRControls from './controls'
import VRHotspot from './hotspot'
import VRPanoramaVideo from './panorama-video';
import { useRef } from 'react';
import {  de, en, es, fi, fr, nl, pl, pt, ru, sv } from './../../assets/translations'
import { store } from '../../effects/store';
const collections = require('./../../assets/mock-data/collections.json')
const messages = {
    de, en, es, fi, fr, nl, pl, pt, ru, sv
}
const FOV = window.innerWidth < 600 ? 90 : 60

const VRComponent = ({ 
    vr = false, panorama, previewPanorama = "false", hotspots = [], initialPosition = [0, 0, 0], 
    rotate, navigation = null, videoPlaying = null, panoramaVideo, setProgress = () => {}, progress = 0,
    setVideoPlaying = () => {}, currentSite, muted, setLoadedCallback = () => {}
}) => {
    const videoRef = useRef();
    const history = useHistory()
    const [loaded, setLoaded] = React.useState(false)
    const [loading, setLoading] = React.useState(true)
    const [ duration, setDuration ] = React.useState(0);
    const [ currentTime, setCurrentTime ] = React.useState(0);

    const camera = new THREE.PerspectiveCamera(FOV, window.innerWidth / window.innerHeight, 0.1, 1500);

    const createVRCanvas = ({ gl }) => (VRButton.createXR(gl))

    if (window.controls) { if (window.controls.autoRotate !== rotate) { window.controls.autoRotate = rotate; camera.updateProjectionMatrix() } }

    React.useEffect(() => { if (vr === false && window.gl?.xr?.enabled === true) { window.gl.xr.enabled = false; window.location.reload() } }, [vr])

    React.useEffect(() => { camera.position.set(...initialPosition) }, [camera])
    React.useEffect(() => { camera.position.set(...initialPosition) }, [initialPosition])
    React.useEffect(() => { 
        loaded && setLoaded(false); 
        (!loading && !loaded)  && setLoading(true) 
    }, [panorama])
    React.useEffect(() => { 
        const t = setTimeout(() => {
            if(loaded){
                setLoading(false)
                setLoaded(false)
            }
        }, 100); 
        return () => clearTimeout(t) 
    }, [panorama])

    React.useEffect(() => {
        setLoadedCallback(loaded)
    }, [loaded])

    React.useEffect(() => {
        if(videoPlaying){
            if (videoRef && videoRef.hasOwnProperty("current")) {
                // setAudioMuted(true)
                videoRef.current.play();
            }
        }else if(videoPlaying === false){
            if (videoRef && videoRef.hasOwnProperty("current")) {
                // if(muted === true)  setAudioMuted()
                videoRef.current.pause();
            }
        }
    }, [videoPlaying])

    React.useEffect(() => {
    }, [videoRef])

    const setProgressVideo = () => {
      let currentTime = videoRef?.current?.currentTime
      let perc = (currentTime / duration * 100).toFixed(2);
      setProgress(perc)
    }

    React.useEffect(() => {
        setProgressVideo()
    }, [currentTime])

    const setCollectionClick = (id) => {
        let collection = collections.find(x => x.collection === id)
        if(collection !== undefined){
            store.dispatch(setCurrentGama(collection.gama))
            store.dispatch(setCurrentCollection(collection))
            store.dispatch(setCurrentStep("collection"))
            store.dispatch(setMenuContent("products"))
            store.dispatch(setMenu(true))
        }
    }
    
    return (
        <div className="fullscreen">
            <div className="gradient-fullscreen" />
            
            <video
                ref={videoRef}
                autoPlay
                crossOrigin="anonymous"
                style={{ display: "none" }}
                onEnded={() => {
                    setCurrentTime(0)
                    setProgressVideo(0)
                    setVideoPlaying()
                }}
                preload="metadata" 
                onLoadedMetadata={(event) => {                   
                  setDuration(event?.target?.duration)
                }}
                onTimeUpdate={(event) => {
                  setCurrentTime(event?.target?.currentTime)
                }}
            >
                {(panoramaVideo !== '' && panoramaVideo !== undefined) && (<source src={panoramaVideo} />)}
            </video>
            {vr && (
                <VRCanvas onCreated={createVRCanvas} camera={camera} pixelRatio={window.devicePixelRatio}>
                    <VRControls initialPosition={initialPosition} />
                    <VRMain map={panorama} loaded={true} setLoaded={() => { }} />
                    <DefaultXRControllers />
                </VRCanvas>
            )}
            {!vr && (
                <ReactReduxContext.Consumer>
                    {({ store }) => {
                        const locale =  store.getState().app.locale;
                        return (
                            <Canvas camera={camera} pixelRatio={window.devicePixelRatio} colorManagement={false}>
                                <ambientLight />
                                <Provider store={store}>
                                    <VRControls initialPosition={initialPosition} />
                                    {!videoPlaying && hotspots?.filter(x => x.geometry === 'square').map((hotspot, i) => (
                                        <VRHotspot 
                                            square 
                                            history={history}
                                            hotspot={hotspot}
                                            key={i}
                                            camera={camera} 
                                            onClickVideo={(hovered) => { 
                                                store.dispatch(setVideo(!hovered, hotspot.video))
                                            }} 
                                            onClickInfo={(hovered, id) => { 
                                                store.dispatch(setInfo(!hovered, id, hotspot.type))
                                            }}
                                            onClickLayer={(hovered, id) => { 
                                                store.dispatch(setInfo(!hovered, id, hotspot.type))
                                            }}
                                            onClickCollection={(hovered, id) => { 
                                                setCollectionClick(id)
                                            }} 
                                            messages={messages} locale={locale}
                                        />
                                    ))}
                                    {!videoPlaying && hotspots?.filter(x => x.geometry !== 'square').map((hotspot, i) => (
                                        <VRHotspot 
                                            circle 
                                            history={history}
                                            hotspot={hotspot}
                                            key={i}
                                            camera={camera} 
                                            onClickVideo={(hovered) => { 
                                                store.dispatch(setVideo(!hovered, hotspot.video))
                                            }} 
                                            onClickInfo={(hovered, id) => { 
                                                store.dispatch(setInfo(!hovered, id, hotspot.type))
                                            }}
                                            onClickLayer={(hovered, id) => { 
                                                store.dispatch(setInfo(!hovered, id, hotspot.type))
                                            }}
                                            onClickCollection={(hovered, id) => { 
                                                setCollectionClick(id)
                                            }} 
                                           
                                            messages={messages} locale={locale}
                                        />
                                    ))}
                                    <VRMain map={panorama} loaded={loaded} setLoaded={setLoaded} visible={!videoPlaying} />
                                    <VRPanoramaVideo map={panoramaVideo} video={videoRef} loaded={loaded} setLoaded={setLoaded} visible={videoPlaying} muted={muted} />
                                </Provider>
                            </Canvas>
                        )
                    }}
                </ReactReduxContext.Consumer>
            )}
        </div>
    )
}
export default React.memo(VRComponent)